import React, { useMemo } from 'react';

import { ShareUpToMessageContext } from './ShareUpToMessageContext';
import type {
	ShareUpToMessageContextValue,
	ShareUpToMessageProviderProps,
} from './shareUpToMessageTypes';

export const ShareUpToMessageProvider = ({
	children,
	shareUpToMessage,
	isMessageShareable,
	shareDisabledReason,
}: ShareUpToMessageProviderProps): React.JSX.Element => {
	const value = useMemo<ShareUpToMessageContextValue>(
		() => ({ shareUpToMessage, isMessageShareable, shareDisabledReason }),
		[shareUpToMessage, isMessageShareable, shareDisabledReason],
	);
	return (
		<ShareUpToMessageContext.Provider value={value}>{children}</ShareUpToMessageContext.Provider>
	);
};
